import { type Stages, availableStages, stageIcons } from '@/impactReports/impactReport.types';
import { stageDisplayStringByIndex } from '@/impactReports/impactReport.utilities';
import { Icon } from '@seeqdev/qomponents';
import type { ICellRendererParams } from '@seeqdev/ag/grid';

/**
 * This cell-renderer renders a little icon next to the use case status to indicate the current stage of the use case.
 */
export const UseCaseStatusCellRenderer = (props: ICellRendererParams<any, string>) => {
  if (!props?.value) return null;
  const { value } = props;
  if (!value) return null;
  const normalizedStage = value.trim().toLowerCase() as Stages;
  let stageIndex = availableStages.indexOf(normalizedStage);

  if (stageIndex < 0) stageIndex = 0;

  return stageIndex >= 0 ? (
    <div className="flexColumnContainer tw:items-center">
      <Icon icon={stageIcons[stageIndex]} extraClassNames="mr5" testId="stageIcon" />
      {stageDisplayStringByIndex(stageIndex)}
    </div>
  ) : null;
};
